import React from 'react'
import Alert from 'react-bootstrap/Alert'
import PropTypes from 'prop-types'
import styled from 'styled-components'
const Error = styled(Alert)`
  text-align: ${props => props.theme.reverseDir};
`
export default function AuthError(props) {
  const { error } = props
  return (
    <Error variant="danger">
      {typeof error === 'object' ? (
        error.map((val, index) => <li key={index}>{val}</li>)
      ) : (
        <li>{error}</li>
      )}
    </Error>
  )
}

AuthError.propTypes = {
  error: PropTypes.any,
}
